import React, { Fragment, useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from "react-router-dom";

// Importamos las constantes configuradas para PHP
import { API_URL, BASE_URL } from './Parametrizaciones.js';

function Buscar() {
    const navigate = useNavigate();
    const location = useLocation(); // Requerido para leer queryParams
    const [listInmueble, setInmueble] = useState([]);

    const clickToPropiedad = (codigo) => {
        navigate(`/propiedades/${codigo}`);
    };

    useEffect(() => {
        const fetchResultados = async () => {
            const queryParams = new URLSearchParams(location.search);
            const codigo = queryParams.get('codigo');

            let url = '';

            // Si la URL no trae ninguna query string, trae todos los inmuebles
            if (!location.search) {
                url = `${API_URL}?action=todosInmuebles`;
            } else if (codigo) {
                // Si viene un código
                url = `${API_URL}?action=getInmuebleByCodigo&codigo=${encodeURIComponent(codigo)}`;
            } else {
                // Si vienen filtros en la URL
                url = `${API_URL}?action=getInmuebleFiltro&${queryParams.toString()}`;
            }

            try {
                const res = await fetch(url);
                if (!res.ok) {
                    throw new Error('Error en la respuesta del servidor');
                }
                const data = await res.json();

                // Si la consulta por código o filtro devuelve un objeto directo en lugar de un Array, 
                // lo envolvemos en un array para evitar que el .map() falle.
                if (data && !Array.isArray(data)) {
                    setInmueble([data]);
                } else {
                    setInmueble(data || []);
                }
            } catch (err) {
                console.error("Error al obtener los resultados:", err);
                setInmueble([]);
            }
        };

        fetchResultados();
    }, [location.search]);

    return (
       <Fragment>

            {/* ENCABEZADO DE LA SECCIÓN */}
            <div className="text-center my-5">
                <a href='/' className="d-inline-flex align-items-center justify-content-center p-3 bg-light rounded-circle shadow-sm mb-3 home-icon-link">
                    <svg width="36" height="36" fill="currentColor" className="bi bi-house-fill" viewBox="0 0 16 16" style={{ color: '#59abe3' }}>
                        <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293z" />
                        <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293z" />
                    </svg>
                </a>
                <h2 className="fw-bold text-dark display-6 mb-1">Resultado de la Búsqueda</h2>
                <p className="text-muted fw-light fs-5">Explora las opciones disponibles adaptadas a tus preferencias</p>
            </div>

            {/* GRILLA DE PROPIEDADES (3 COLUMNAS EN PANTALLAS GRANDES) */}
            <div className="container-fluid px-lg-5 mb-5">
                <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
                    {listInmueble.length === 0 ? (
                        <div className="col-12 text-center my-5 py-5 bg-white border-0 shadow-sm" style={{ borderRadius: '28px' }}>
                            <div className="p-4 d-inline-block rounded-circle bg-light mb-3">
                                <i className="fa fa-search text-muted" style={{ fontSize: "48px" }}></i>
                            </div>
                            <h3 className="fw-bold text-dark fs-3 mb-2">
                                No se encontraron inmuebles
                            </h3>
                            <p className="text-muted fs-5 mb-0">Intenta realizar una nueva búsqueda con otros criterios o filtros.</p>
                        </div>
                    ) : (
                        [...listInmueble].sort((a, b) => Number(b.CODIGO_INMUEBLE) - Number(a.CODIGO_INMUEBLE)).map(Inmueble => (
                            <div key={Inmueble.CODIGO_INMUEBLE} className="col d-flex">

                                {/* TARJETA PRINCIPAL */}
                                <div
                                    className="card w-100 border-0 shadow-sm p-3 bg-white d-flex flex-column text-center property-card"
                                    style={{
                                        borderRadius: '24px',
                                        transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                                    }}
                                >

                                    {/* 1. ENCABEZADO */}
                                    <div className="pt-2 px-2 mb-2">
                                        <h2 style={{ color: "#b83535", margin: 0, fontWeight: "bold" }}>
                                            {Inmueble.TIPO_INMUEBLE}
                                        </h2>
                                        <h3 style={{ color: "#826c6c", margin: "2px 0" }}>
                                            {Inmueble.OPCION_INMUEBLE}
                                        </h3>
                                        <p className="text-muted" style={{ margin: 0 }}>
                                            {Inmueble.MUNICIPIO}, {Inmueble.BARRIO}
                                        </p>
                                    </div>

                                    {/* 2. CONTENEDOR DE LA IMAGEN */}
                                    <div
                                        className="position-relative overflow-hidden property-img-container mb-3"
                                        style={{ height: "260px", borderRadius: "18px" }}
                                    >
                                        <img
                                           src={`${BASE_URL}/dbimages/${Inmueble.IMAGEN_PRINCIPAL}`}
                                            alt={Inmueble.TIPO_INMUEBLE}
                                            onClick={() => clickToPropiedad(Inmueble.CODIGO_INMUEBLE)}
                                            className="w-100 h-100 property-img"
                                            style={{ objectFit: "cover", cursor: "pointer", transition: 'transform 0.4s ease' }}
                                        />
                                        {/* Badge Cápsula con el código */}
                                        <span
                                            className="position-absolute top-0 start-0 m-3 bg-primary text-white fw-bold px-3 py-1 rounded-pill shadow-sm"
                                            style={{ fontSize: "11px", letterSpacing: "0.5px" }}
                                        >
                                            CÓDIGO: {Inmueble.CODIGO_INMUEBLE}
                                        </span>
                                    </div>

                                    {/* 3. FRANJA ROJA CON ÍCONOS */}
                                    <div
                                        className="py-2 px-3 text-white mb-3 shadow-sm"
                                        style={{ background: "#b83535", borderRadius: "16px" }}
                                    >
                                        <div className="d-flex justify-content-around align-items-center">
                                            <span className="d-inline-flex align-items-center gap-1">
                                                <i className="fa fa-bed" style={{ fontSize: "18px" }}></i>
                                                <span className="fw-semibold" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "15px" }}>
                                                    {Inmueble.HABITACIONES}
                                                </span>
                                            </span>

                                            <span style={{ opacity: 0.4 }}>|</span>

                                            <span className="d-inline-flex align-items-center gap-1">
                                                <i className="fa fa-car" style={{ fontSize: "18px" }}></i>
                                                <span className="fw-semibold" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "15px" }}>
                                                    {Inmueble.PARQUEADERO}
                                                </span>
                                            </span>

                                            <span style={{ opacity: 0.4 }}>|</span>

                                            <span className="d-inline-flex align-items-center gap-1">
                                                <i className="fa fa-bath" style={{ fontSize: "18px" }}></i>
                                                <span className="fw-semibold" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "15px" }}>
                                                    {Inmueble.BANOS}
                                                </span>
                                            </span>
                                        </div>
                                    </div>

                                    {/* 4. ÁREA Y PRECIO */}
                                    <div className="mt-auto pt-2">
                                        <div className="row g-2 justify-content-center align-items-center">

                                            {/* ÁREA */}
                                            <div className="col-12 pb-2 border-bottom">
                                                <span className="fw-bold d-block text-secondary small">ÁREA / SUPERFICIE:</span>
                                                <span className="fw-semibold text-dark">{Inmueble.AREA} m²</span>
                                            </div>

                                            {/* PRECIO (Recuadro adaptable que resalta como el ejemplo) */}
                                            <div className="col-12 mt-2 p-2 rounded" style={{ backgroundColor: "#fdf8f8", border: "1px solid #f2d6d6" }}>
                                                <span className="fw-bold d-block text-secondary" style={{ fontSize: "11px" }}>PRECIO:</span>
                                                <h2 className="m-0 text-truncate fw-bold" style={{ color: "#826c6c" }}>
                                                    {Inmueble.PRECIO}
                                                </h2>
                                            </div>

                                        </div>

                                        {/* BOTÓN / ENLACE DE INFORMACIÓN */}
                                        <div className="mt-3 pt-1 text-center">
                                            <Link
                                                to={`/propiedades/${Inmueble.CODIGO_INMUEBLE}`}
                                                className="text-decoration-none fw-semibold d-inline-flex align-items-center gap-1 info-link"
                                                style={{ color: "#b83535", fontSize: "14px" }}
                                            >
                                                <span>Ver más información</span>
                                                <i className="fa fa-arrow-right small"></i>
                                            </Link>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        ))
                    )}
                </div>
            </div>

            {/* PAGINACIÓN */}
            <div className="my-5 d-flex justify-content-center">
                <nav aria-label="Navegación de páginas">
                    <ul className="pagination pagination-rounded gap-1">
                        <li className="page-item disabled">
                            <a className="page-link rounded-pill px-3 border-0 shadow-sm" href="#" tabIndex="-1">
                                &laquo; Anterior
                            </a>
                        </li>
                        <li className="page-item active">
                            <a
                                className="page-link rounded-circle border-0 shadow-sm d-flex align-items-center justify-content-center text-white"
                                style={{ width: '40px', height: '40px', backgroundColor: '#b83535' }}
                                href="#"
                            >
                                1
                            </a>
                        </li>
                        <li className="page-item">
                            <a className="page-link rounded-circle border-0 shadow-sm text-dark d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }} href="#">2</a>
                        </li>
                        <li className="page-item">
                            <a className="page-link rounded-circle border-0 shadow-sm text-dark d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }} href="#">3</a>
                        </li>
                        <li className="page-item">
                            <a className="page-link rounded-pill px-3 border-0 shadow-sm text-dark" href="#">
                                Siguiente &raquo;
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>

        </Fragment>
    );
}

export default Buscar;